import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as d, createElementVNode as o } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconDoubleCheck",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.354.646a.5.5 0 0 1 0 .708l-5.5 5.5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 1 1 .708-.708L3.5 5.793 8.646.646a.5.5 0 0 1 .708 0Zm2 2a.5.5 0 0 1 0 .708l-3.75 3.75a.5.5 0 0 1-.708 0l-.75-.75a.5.5 0 1 1 .708-.708l.396.397 3.396-3.397a.5.5 0 0 1 .708 0Z",
  fill: "currentColor"
}, null, -1), u = [
  _
];
function m(a, h, i, f, p, e) {
  return l(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([e.iconSizeClass, "d-icon d-icon--double-check"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Double Check",
    viewBox: "0 0 12 8",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const C = /* @__PURE__ */ n(s, [["render", m]]);
export {
  C as default
};
//# sourceMappingURL=double-check.js.map
